<div class="card ">
  <div [class]="config('title_pop_send_friend')?.class ? 'card-header card-header-icon ' + config('title_pop_send_friend')?.class : config('title_pop_send_friend')?.class">
    <div class="card-icon">
      <i [class]="config('title_pop_send_friend')?.icon"></i>
    </div>
    <h4 [class]="config('title_pop_send_friend')?.param1 ? 'card-title ' + config('title_pop_send_friend')?.param1 : 'card-title'">Envoyer l'offre à un(e) ami(e)</h4>
  </div>
  <div class="card-body ">
    <form [formGroup]="controlForm">
      <mat-form-field [color]="param.color" class="example-full-width" (input)="optionnal()" [class.has-danger]="email.invalid" [class.has-succes]="email.valid">
        <input matInput placeholder="Adresse email du destinataire" type="email" formControlName="email" required>
        <span class="form-control-feedback" *ngIf="email.valid">
          <i class="material-icons">done</i>
        </span>
        <span class="form-control-feedback" *ngIf="email.invalid">
          <i class="material-icons">clear</i>
        </span>
      </mat-form-field>
      <mat-form-field [color]="param.color" class="example-full-width" (input)="optionnal()" id="sms" [class.has-danger]="sms.invalid" [class.has-succes]="sms.valid">
        <input matInput placeholder="Numéro de téléphone du destinataire (SMS gratuit)" type="tel" formControlName="sms" required>
        <span class="form-control-feedback" *ngIf="sms.valid">
          <i class="material-icons">done</i>
        </span>
        <span class="form-control-feedback" *ngIf="sms.invalid">
          <i class="material-icons">clear</i>
        </span>
      </mat-form-field>
    </form>
  </div>
  <div class="card-footer ">
    <button (click)="onNoClick()"
            [class]="config('btn_cancel_pop_send_friend')?.class ? 'btn btn-fill ' + config('btn_cancel_pop_send_friend')?.class : 'btn btn-fill'">
      {{ config('btn_cancel_pop_send_friend')?.txt }}
    </button>
    <button mat-raised-button (click)="onClick()" [disabled]="controlForm.invalid" type="submit" [class]="config('btn_valid_pop_send_friend')?.class ? 'btn btn-fill ' + config('btn_valid_pop_send_friend')?.class : 'btn btn-fill'">
      {{ config('btn_valid_pop_send_friend')?.txt }}
    </button>
  </div>
</div>
